export const STATUS_OPTIONS = [
  { value: "Đang hoạt động", label: "Đang hoạt động" },
  { value: "Ngừng hoạt động", label: "Ngừng hoạt động" },
];

export const GENDER_OPTIONS = [
  { value: "Nam", label: "Nam" },
  { value: "Nữ", label: "Nữ" },
];
